import { render, staticRenderFns } from "./ProviderEdit.vue?vue&type=template&id=3bec5383&scoped=true"
import script from "./ProviderEdit.vue?vue&type=script&lang=js"
export * from "./ProviderEdit.vue?vue&type=script&lang=js"
import style0 from "./ProviderEdit.vue?vue&type=style&index=0&id=3bec5383&lang=sass"
import style1 from "./ProviderEdit.vue?vue&type=style&index=1&id=3bec5383&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bec5383",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bec5383')) {
      api.createRecord('3bec5383', component.options)
    } else {
      api.reload('3bec5383', component.options)
    }
    module.hot.accept("./ProviderEdit.vue?vue&type=template&id=3bec5383&scoped=true", function () {
      api.rerender('3bec5383', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/ProviderEdit.vue"
export default component.exports